import type { ReactNode } from "react"

const countWordsInText = (value: string): number =>
  value
    .trim()
    .split(/\s+/)
    .filter(Boolean).length

const countWordsInNode = (node: ReactNode): number => {
  if (node === null || node === undefined || typeof node === "boolean") {
    return 0
  }

  if (typeof node === "string" || typeof node === "number") {
    return countWordsInText(String(node))
  }

  if (Array.isArray(node)) {
    return node.reduce((total, child) => total + countWordsInNode(child), 0)
  }

  if (typeof node === "object" && "props" in node) {
    const element = node as { props?: { children?: ReactNode } }
    return countWordsInNode(element.props?.children)
  }

  return 0
}

export function calculateReadTime(articleBody: ReactNode[]): number {
  const wordsPerMinute = 200
  const totalWords = articleBody.reduce<number>((total, node) => total + countWordsInNode(node), 0)

  return Math.ceil(totalWords / wordsPerMinute)
}
